/**
 * Shared Tailwind class strings for home-themed action buttons.
 * Used across the Home, Topics, and Practice pages.
 */

export const primaryActionClass =
  'home-rounded inline-flex items-center justify-center rounded-2xl border border-[#5b6472] bg-[#4d5561] px-6 py-2.5 text-base font-semibold text-white shadow-[0_3px_10px_rgba(45,52,63,0.18)] transition-all duration-150 hover:bg-[#404752] hover:shadow-[0_5px_14px_rgba(45,52,63,0.23)]';

export const secondaryActionClass =
  'home-rounded inline-flex items-center justify-center rounded-2xl border border-[#7f8ea3] bg-[#738196] px-6 py-2.5 text-base font-semibold text-white shadow-[0_3px_10px_rgba(74,89,110,0.18)] transition-all duration-150 hover:bg-[#657287] hover:shadow-[0_5px_14px_rgba(74,89,110,0.23)]';

export const authPrimaryActionClass =
  'home-rounded inline-flex w-full justify-center rounded-2xl border border-[#5b6472] bg-[#4d5561] px-6 py-2.5 text-base font-semibold text-white shadow-[0_3px_10px_rgba(45,52,63,0.18)] transition-all duration-150 hover:bg-[#404752] hover:shadow-[0_5px_14px_rgba(45,52,63,0.23)]';

export const authSecondaryActionClass =
  'home-rounded inline-flex w-full justify-center rounded-2xl border border-[#7f8ea3] bg-[#738196] px-6 py-2.5 text-base font-semibold text-white shadow-[0_3px_10px_rgba(74,89,110,0.18)] transition-all duration-150 hover:bg-[#657287] hover:shadow-[0_5px_14px_rgba(74,89,110,0.23)]';

export const modalPrimaryActionClass =
  'home-rounded inline-flex w-full items-center justify-center rounded-2xl border border-[#5b6472] bg-[#4d5561] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_3px_10px_rgba(45,52,63,0.18)] transition-all duration-150 hover:bg-[#404752] hover:shadow-[0_5px_14px_rgba(45,52,63,0.23)] sm:text-base';

export const modalSecondaryActionClass =
  'home-rounded inline-flex w-full items-center justify-center rounded-2xl border border-[#7f8ea3] bg-[#738196] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_3px_10px_rgba(74,89,110,0.18)] transition-all duration-150 hover:bg-[#657287] hover:shadow-[0_5px_14px_rgba(74,89,110,0.23)] sm:text-base';

export const primaryActionDisabledClass =
  'cursor-not-allowed opacity-60 hover:bg-[#4d5561] hover:shadow-[0_3px_10px_rgba(45,52,63,0.18)]';

export const secondaryActionDisabledClass =
  'cursor-not-allowed opacity-60 hover:bg-[#738196] hover:shadow-[0_3px_10px_rgba(74,89,110,0.18)]';

export const authLabelClass = 'home-rounded mb-1 block text-sm font-semibold text-[#4f596b] dark:text-secondary-200';

export const authInputClass =
  'home-rounded w-full rounded-xl border border-[#b8c3d2] bg-white px-3 py-2.5 text-[#4f596b] placeholder:text-[#8a97ac] shadow-[0_1px_4px_rgba(95,108,129,0.08)] outline-none transition-all focus:border-[#8f9db3] focus:ring-2 focus:ring-[#c7d1df] dark:border-secondary-600 dark:bg-secondary-800 dark:text-secondary-100 dark:placeholder:text-secondary-400 dark:focus:border-secondary-500 dark:focus:ring-secondary-700';

export const authPasswordToggleClass =
  'absolute inset-y-0 right-0 flex items-center pr-3 text-[#6b7484] transition-colors hover:text-[#4f596b] dark:text-secondary-400 dark:hover:text-secondary-200';

export const errorTextClass = 'mt-1 text-sm text-[#a03a3a] dark:text-rose-300';

export const cardClass =
  'rounded-2xl border border-[#d2d8e2] bg-[#f1f2f5] p-6 shadow-[0_5px_14px_rgba(66,78,96,0.16)] dark:border-secondary-700 dark:bg-secondary-800';

export const sectionBgClass = 'bg-[#f1f2f5] dark:bg-[#1a2332]';

export const pageTitleClass = 'home-rounded text-4xl font-semibold text-[#5a6170] sm:text-5xl dark:text-secondary-100';

export const pageSubtitleClass = 'mt-2 text-base text-[#5d6674] sm:text-lg dark:text-secondary-300';

export const compactSecondaryActionClass =
  'home-rounded inline-flex items-center justify-center rounded-xl border border-[#b8c3d2] bg-[#e9eef5] px-4 py-2 text-sm font-semibold text-[#4d5a70] shadow-[0_2px_8px_rgba(92,107,127,0.12)] transition-all duration-150 hover:bg-[#dfe6ef]';

export const questionActionPrimaryClass =
  'home-rounded inline-flex items-center justify-center rounded-xl border border-[#5b6472] bg-[#4d5561] px-4 py-2 text-base font-semibold text-white shadow-[0_3px_10px_rgba(45,52,63,0.18)] transition-all duration-150 hover:bg-[#404752]';

export const questionActionSecondaryClass =
  'home-rounded inline-flex items-center justify-center rounded-xl border border-[#b8c3d2] bg-[#e9eef5] px-4 py-2 text-base font-semibold text-[#4d5a70] shadow-[0_2px_8px_rgba(92,107,127,0.12)] transition-all duration-150 hover:bg-[#dfe6ef]';
